var React = require('react');

function Share (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"currentColor","strokeWidth":"2","d":"M1 12v11.5h20V12","key":0}),React.createElement("path",{"fill":"currentColor","d":"M11.7 1.988v14.52H9.885V1.987z","key":1}),React.createElement("path",{"fill":"currentColor","d":"M11.004.5 18 7.496 16.717 8.78 9.72 1.784z","key":2}),React.createElement("path",{"fill":"currentColor","d":"M11.7 2.363 5.283 8.78 4 7.497l6.417-6.417z","key":3})]);
}

Share.defaultProps = {"width":"22","height":"25","fill":"none"};

module.exports = Share;

Share.default = Share;
